var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { useState } from 'react';
import { useKeyPressEvent } from 'react-use';
import { IoBackspaceOutline } from 'react-icons/io5';
import { useKeypadContext } from './KeypadProvider';
var variants = {
    down: { scale: 0.8 },
    rest: { scale: 1 },
};
export var BackspaceKey = function (_a) {
    var className = _a.className, onClick = _a.onClick, iconStyle = _a.iconStyle;
    var disableKeypadKeyboard = useKeypadContext().disableKeypadKeyboard;
    var _b = useState(false), isDown = _b[0], setIsDown = _b[1];
    var handleMouseDown = function () {
        if (disableKeypadKeyboard)
            return;
        setIsDown(true);
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    var handleMouseUp = function () { return setIsDown(false); };
    useKeyPressEvent('Backspace', handleMouseDown, handleMouseUp);
    return (_jsx(motion.div, __assign({ animate: isDown ? 'down' : 'rest', variants: variants, className: "grid place-items-center" }, { children: _jsx(IoBackspaceOutline, { className: className, style: iconStyle, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, "aria-label": "Backspace" }) })));
};
export default BackspaceKey;
